export const FieldTypes = {
  TEXT: 'text',
  CHECKBOX: 'checkbox',
  SINGLE_CHECKBOX: 'booleancheckbox',
  RADIO: 'radio',
  SELECT: 'select',
  DATE: 'date',
  TEXTAREA: 'textarea',
  NUMBER: 'number',
  FILE: 'file',
  PHONE: 'phone',
  MOBILE_PHONE: 'mobilephone',
  SUBMIT: 'submit'
};
export const EmailField = 'email';
export const FirstNameField = 'firstname';
export const LastNameField = 'lastname';